// src/pages/LoginPage.tsx

import React, { useState } from 'react';
import { Form, Input, Button, notification, Spin } from 'antd';
import { login } from '../services/api-service'; // Импорт функции login из вашего сервиса
import { useNavigate } from 'react-router-dom';

interface LoginValues {
    username: string;
    password: string;
}

interface ValidationError {
    errorFields: { errors: string[] }[];
}

const LoginPage: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const onFinish = async (values: LoginValues) => {
        const { username, password } = values;
        setLoading(true);

        try {
            await login({ username, password });
            setLoading(false);
            navigate('/documents'); // Переход на главную страницу или куда необходимо
        } catch (error: any) {
            setLoading(false);
            notification.error({
                message: 'Ошибка входа',
                description: error.response?.data?.error || 'Неправильный логин или пароль',
            });
        }
    };

    const onFinishFailed = (errorInfo: ValidationError) => {
        notification.error({
            message: 'Ошибка валидации',
            description: errorInfo.errorFields[0]?.errors[0] || 'Ошибка валидации формы',
        });
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <div className="flex flex-col items-center mb-4">
                {loading && <Spin />}
            </div>
            <Form
                name="login_form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="login-form w-full max-w-xs"
            >
                <Form.Item
                    name="username"
                    rules={[{ required: true, message: 'Пожалуйста, введите имя пользователя!' }]}
                >
                    <Input type="text" placeholder="Имя пользователя" disabled={loading} />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Пожалуйста, введите ваш пароль!' }]}
                >
                    <Input.Password placeholder="Пароль" disabled={loading} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="w-full" loading={loading}>
                        Войти
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default LoginPage;
